import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import style from '../../../components/grid-header/reusable-grid-button.module.less';

type AddSuppliersButtonProps = {
  disabled?: boolean;
  onAddSupplier: () => void;
};

export const AddSuppliersButton = ({ disabled, onAddSupplier }: AddSuppliersButtonProps) => {
  const buttonText = <FormattedMessage {...messages.addSupplierButton} />;
  const buttonTheme = THEME_CONSTANTS.primary;

  return (
    <Button className={style['reusable-button']} disabled={disabled} onClick={onAddSupplier} theme={buttonTheme}>
      {buttonText}
    </Button>
  );
};
